// polyfills
import 'core-js/stable';
import 'regenerator-runtime/runtime';
import smoothscroll from 'smoothscroll-polyfill';
import 'intersection-observer';

import Vue from 'vue';

import breakpoint from '@/services/breakpoint';
import resizeMixin from '@/mixins/resize';

// Main app
import '@/styles/main.scss';

import App1 from './App1Timeline.vue';
import App2 from './App2BubbleCluster.vue';
import App3 from './App3BubbleGrid.vue';
import App4 from './App4ColumnChart.vue';
import App5 from './App5BarChart.vue';

// kick off the polyfill
smoothscroll.polyfill();

// register global mixin
Vue.mixin({
  beforeCreate() {
    this.$breakpoint = Vue.observable(breakpoint);
  },
  ...resizeMixin,
});

Vue.config.productionTip = false;

new Vue({
  render: (h) => h(App1),
}).$mount('#app-viz-timeline');

new Vue({
  render: (h) => h(App2),
}).$mount('#app-viz-bubble-cluster');

new Vue({
  render: (h) => h(App3),
}).$mount('#app-viz-bubble-grid');

new Vue({
  render: (h) => h(App4),
}).$mount('#app-viz-column-chart');

new Vue({
  render: (h) => h(App5),
}).$mount('#app-viz-bar-chart');